import { render, staticRenderFns } from "./LMCreateModuleDialog.vue?vue&type=template&id=831717ba&"
import script from "./LMCreateModuleDialog.vue?vue&type=script&lang=ts&"
export * from "./LMCreateModuleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LMCreateModuleDialog.vue?vue&type=style&index=0&id=831717ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports